"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleSectionTemplateStore = void 0;
class RoleSectionTemplateStore {
    data = {};
    constructor() {
        this.data = {};
    }
    add(s) {
        this.data[s.getId()] = s;
    }
    byId(id) {
        return this.data[id];
    }
    query(options) {
        return Object.values(this.data).filter(r => {
            if (options?.roleSectionId && r.getRoleSectionId() != options.roleSectionId) {
                return false;
            }
            if (options?.assignedDate) {
                const hasDate = r.assignedDates.some(d => {
                    const optionDate = options.assignedDate;
                    if (!optionDate) {
                        return;
                    }
                    const isSameDate = d.getFullYear() === optionDate.getFullYear() &&
                        d.getMonth() === optionDate.getMonth() &&
                        d.getDate() === optionDate.getDate();
                    return isSameDate;
                });
                if (!hasDate) {
                    return false;
                }
                ;
            }
            return true;
        });
    }
    delete(id) {
        delete this.data[id];
    }
}
exports.RoleSectionTemplateStore = RoleSectionTemplateStore;
